// Base URL of the blog backend, trailing slash stripped. Empty string when unset
// so callers build relative paths that fail loudly rather than hitting a wrong host.
export function blogApiBase(): string {
  return (process.env.REACT_APP_BLOG_API_URL ?? '').replace(/\/$/, '');
}
